import React from 'react';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white pt-24 pb-12 border-t border-gray-100">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20">
          {/* Coluna Logo e Social */}
          <div className="space-y-8">
            <Logo className="h-10" />
            <p className="text-gray-400 text-sm font-bold leading-relaxed">
              Líder em infraestrutura energética e investimentos reais. ENERGY SOLARIS © 2025.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/p/Energy-Solaris-61574867182977/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center hover:bg-[#39B54A] hover:text-white transition-all text-gray-600">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-8.783h-2.954v-3.429h2.954v-2.527c0-2.925 1.787-4.516 4.396-4.516 1.25 0 2.324.093 2.637.135v3.058h-1.809c-1.419 0-1.693.675-1.693 1.662v2.188h3.386l-.441 3.429h-2.945v8.783h6.135c.731 0 1.325-.593 1.325-1.324v-21.351c0-.732-.594-1.325-1.325-1.325z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/energy_solaris25/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center hover:bg-[#39B54A] hover:text-white transition-all text-gray-600">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Coluna A Empresa */}
          <div>
            <h4 className="text-gray-900 font-black mb-6 uppercase text-xs tracking-widest">A Empresa</h4>
            <ul className="space-y-4 text-sm text-gray-500 font-bold">
              <li><a href="#sobre" className="hover:text-[#39B54A] transition-colors">Sobre a Energy Solaris</a></li>
              <li><a href="#" className="hover:text-[#39B54A] transition-colors">Modelo de Negócio</a></li>
              <li><a href="#solucoes" className="hover:text-[#39B54A] transition-colors">Soluções Técnicas</a></li>
              <li><a href="#diferenciais" className="hover:text-[#39B54A] transition-colors">Diferenciais</a></li>
            </ul>
          </div>

          {/* Coluna Legal */}
          <div>
            <h4 className="text-gray-900 font-black mb-6 uppercase text-xs tracking-widest">Legal</h4>
            <ul className="space-y-4 text-sm text-gray-500 font-bold">
              <li><a href="#" className="hover:text-[#39B54A] transition-colors">Termos e Condições</a></li>
              <li><a href="#" className="hover:text-[#39B54A] transition-colors">Política de Privacidade</a></li>
              <li><a href="#" className="hover:text-[#39B54A] transition-colors">Aviso de Risco (Disclaimer)</a></li>
              <li><a href="#" className="hover:text-[#39B54A] transition-colors">Compliance</a></li>
            </ul>
          </div>

          {/* Coluna Suporte */}
          <div>
            <h4 className="text-gray-900 font-black mb-6 uppercase text-xs tracking-widest">Suporte</h4>
            <ul className="space-y-4 text-sm text-gray-500 font-bold">
              <li><a href="#" className="hover:text-[#39B54A] transition-colors">Atendimento ao Investidor</a></li>
              <li><a href="#" className="hover:text-[#39B54A] transition-colors">Perguntas Frequentes (FAQ)</a></li>
              <li><a href="#" className="hover:text-[#39B54A] transition-colors">Canal de Denúncias</a></li>
              <li className="text-[#39B54A]">(73) 99859-5834</li>
            </ul>
          </div>
        </div>

        {/* Disclaimer e Copyright */}
        <div className="pt-12 border-t border-gray-100 text-center space-y-6">
          <p className="text-[10px] text-gray-400 font-bold max-w-4xl mx-auto leading-relaxed uppercase tracking-wider">
            Disclaimer: O investimento em energias renováveis e ativos reais envolve riscos, incluindo iliquidez e volatilidade. 
            Retornos passados não garantem retornos futuros. Leia o prospecto completo antes de investir. 
            Todas as simulações são baseadas em taxas projetadas e podem variar conforme o mercado.
          </p>
          <p className="text-[10px] text-gray-300 font-black uppercase tracking-[0.2em]">
            ENERGY SOLARIS © 2025 – Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;